var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGradientDeployment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.382 22.335s4.766-4.733 6.383-6.4c5.117-5 2.567-15.3 2.567-15.3s-10.25-2.55-15.25 2.567c-3.9 3.8-6.434 6.433-6.434 6.433s-6.4-1.333-10.233 2.5l20.417 20.467c3.833-3.883 2.55-10.267 2.55-10.267zm-2.5-15a3.333 3.333 0 114.716 4.712 3.333 3.333 0 01-4.716-4.712zm-18.8 23.6a13.016 13.016 0 008.333-3.333l-5-5c-3.333 1.667-3.333 8.333-3.333 8.333z",
    fill: "#DDD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.382 22.335s4.766-4.733 6.383-6.4c5.117-5 2.567-15.3 2.567-15.3s-10.25-2.55-15.25 2.567c-3.9 3.8-6.434 6.433-6.434 6.433s-6.4-1.333-10.233 2.5l20.417 20.467c3.833-3.883 2.55-10.267 2.55-10.267zm-2.5-15a3.333 3.333 0 114.716 4.712 3.333 3.333 0 01-4.716-4.712zm-18.8 23.6a13.016 13.016 0 008.333-3.333l-5-5c-3.333 1.667-3.333 8.333-3.333 8.333z",
    fill: "url(#paint0_linear_3833_2887)",
    fillOpacity: 0.85
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.382 22.335s4.766-4.733 6.383-6.4c5.117-5 2.567-15.3 2.567-15.3s-10.25-2.55-15.25 2.567c-3.9 3.8-6.434 6.433-6.434 6.433s-6.4-1.333-10.233 2.5l20.417 20.467c3.833-3.883 2.55-10.267 2.55-10.267zm-2.5-15a3.333 3.333 0 114.716 4.712 3.333 3.333 0 01-4.716-4.712zm-18.8 23.6a13.016 13.016 0 008.333-3.333l-5-5c-3.333 1.667-3.333 8.333-3.333 8.333z",
    fill: "url(#paint1_linear_3833_2887)",
    fillOpacity: 0.85
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3833_2887",
    x1: -1.124,
    y1: 32.602,
    x2: 32.967,
    y2: 32.602,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.385,
    stopColor: "#DD0510"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.958,
    stopColor: "#7D0006"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3833_2887",
    x1: -1.124,
    y1: 32.602,
    x2: 32.967,
    y2: 32.602,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6C0FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F68084"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGradientDeployment);
export default __webpack_public_path__ + "static/media/gradient-deployment.5977cf4a7634bd4de78bf3f7b331b29f.svg";
export { ForwardRef as ReactComponent };